export interface GoalOption {
    Category: string;
    Goal: string;
}

export const GOAL_OPTIONS: GoalOption[] = [
    {
        "Category": "Weight Management",
        "Goal": "Lose weight"
    },
    {
        "Category": "Weight Management",
        "Goal": "Gain weight"
    },
    {
        "Category": "Weight Management",
        "Goal": "Maintain weight"
    },
    {
        "Category": "Weight Management",
        "Goal": "Reduce body fat %"
    },
    {
        "Category": "Weight Management",
        "Goal": "Improve muscle definition"
    },
    {
        "Category": "Strength & Muscle",
        "Goal": "Build muscle mass"
    },
    {
        "Category": "Strength & Muscle",
        "Goal": "Increase overall strength"
    },
    {
        "Category": "Strength & Muscle",
        "Goal": "Improve core strength"
    },
    {
        "Category": "Strength & Muscle",
        "Goal": "Increase upper-body strength"
    },
    {
        "Category": "Strength & Muscle",
        "Goal": "Increase lower-body strength"
    },
    {
        "Category": "Strength & Muscle",
        "Goal": "Improve functional strength"
    },
    {
        "Category": "Endurance & Performance",
        "Goal": "Improve stamina"
    },
    {
        "Category": "Endurance & Performance",
        "Goal": "Increase cardiovascular endurance"
    },
    {
        "Category": "Endurance & Performance",
        "Goal": "Run longer distances"
    },
    {
        "Category": "Endurance & Performance",
        "Goal": "Improve cycling endurance"
    },
    {
        "Category": "Endurance & Performance",
        "Goal": "Enhance athletic performance"
    },
    {
        "Category": "Endurance & Performance",
        "Goal": "Train for marathon/half-marathon"
    },
    {
        "Category": "Mobility & Flexibility",
        "Goal": "Improve flexibility"
    },
    {
        "Category": "Mobility & Flexibility",
        "Goal": "Improve mobility"
    },
    {
        "Category": "Mobility & Flexibility",
        "Goal": "Reduce muscle stiffness"
    },
    {
        "Category": "Mobility & Flexibility",
        "Goal": "Achieve pain-free movement"
    },
    {
        "Category": "Lifestyle & Habit",
        "Goal": "Build consistent workout routine"
    },
    {
        "Category": "Lifestyle & Habit",
        "Goal": "Improve daily activity level"
    },
    {
        "Category": "Lifestyle & Habit",
        "Goal": "Reduce sedentary behavior"
    },
    {
        "Category": "Lifestyle & Habit",
        "Goal": "Develop healthy habits"
    },
    {
        "Category": "Lifestyle & Habit",
        "Goal": "Improve discipline & consistency"
    },
    {
        "Category": "Health & Wellness",
        "Goal": "Improve heart health"
    },
    {
        "Category": "Health & Wellness",
        "Goal": "Improve lung capacity"
    },
    {
        "Category": "Health & Wellness",
        "Goal": "Improve metabolism"
    },
    {
        "Category": "Health & Wellness",
        "Goal": "Improve sleep quality"
    },
    {
        "Category": "Health & Wellness",
        "Goal": "Boost immunity"
    },
    {
        "Category": "Health & Wellness",
        "Goal": "Reduce stress & anxiety"
    },
    {
        "Category": "Health & Wellness",
        "Goal": "Improve overall energy levels"
    },
    {
        "Category": "Body Composition",
        "Goal": "Tone body"
    },
    {
        "Category": "Body Composition",
        "Goal": "Build lean physique"
    },
    {
        "Category": "Body Composition",
        "Goal": "Improve posture"
    },
    {
        "Category": "Body Composition",
        "Goal": "Correct muscle imbalances"
    },
    {
        "Category": "Sports-Specific",
        "Goal": "Improve speed"
    },
    {
        "Category": "Sports-Specific",
        "Goal": "Improve agility"
    },
    {
        "Category": "Sports-Specific",
        "Goal": "Increase power/explosiveness"
    },
    {
        "Category": "Sports-Specific",
        "Goal": "Enhance balance & coordination"
    },
    {
        "Category": "Sports-Specific",
        "Goal": "Sport-specific conditioning"
    },
    {
        "Category": "Rehabilitation",
        "Goal": "Injury recovery"
    },
    {
        "Category": "Rehabilitation",
        "Goal": "Strengthen injured joints/muscles"
    },
    {
        "Category": "Rehabilitation",
        "Goal": "Improve joint stability"
    },
    {
        "Category": "Rehabilitation",
        "Goal": "Prevent injuries"
    },
    {
        "Category": "Rehabilitation",
        "Goal": "Improve recovery after workouts"
    },
    {
        "Category": "Nutrition",
        "Goal": "Eat cleaner"
    },
    {
        "Category": "Nutrition",
        "Goal": "Build calorie control habit"
    },
    {
        "Category": "Nutrition",
        "Goal": "Improve protein intake"
    },
    {
        "Category": "Nutrition",
        "Goal": "Build long-term nutrition discipline"
    },
    {
        "Category": "Nutrition",
        "Goal": "Improve hydration habits"
    }
];

export const GOAL_CATEGORIES = Array.from(new Set(GOAL_OPTIONS.map(g => g.Category)));
